module.exports = __webpack_public_path__ + "static/hero-752a13b115e7139253b9e50d6c3c0182.jpg";